/* @flow */

import actionTypes from '../actions/actionsFactory/types';


export const INITIAL_STATE = {
  shouldPublicAssets: true,
  isHideHeadLangSeclet: false,
};

export const reducer = (state: Object, action: Object) => {
  switch (action.type) {
    case actionTypes.SET_USER_ASSETS_PUBLIC_STATUS:
      return { ...state, shouldPublicAssets: action.data };
    case actionTypes.HIDE_HEADER_LANG_SELECT:
      return { ...state, isHideHeadLangSeclet: action.data };
    default:
      return state;
  }
};
